<!-- Breadcrumb for application -->
<div class="container">
  <nav aria-label="breadcrumb" class="breadCust">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
      <li class="breadcrumb-item active" aria-current="page">Subscription Module</li>
    </ol>
  </nav>
</div>
<div class="container mt-1 theme-fa-icon" >
  <fieldset class="scheduler-border">
    <legend class="scheduler-border">
      <h5 class="font-weight-bold">Subscription</h5>
    </legend>
    <div class="row">
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/subscription-list">
          <i class="bi bi-layout-three-columns orange-dr-icon" aria-hidden="true"></i>Subscription Data
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/subscriptionLimit">
          <i class="bi bi-tags blue-lt-icon" aria-hidden="true"></i>Subscription Limit
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/subscription-media-list">
          <i class="bi bi-layout-three-columns orange-dr-icon" aria-hidden="true"></i>Subscription Media
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/subscription-feature-list">
          <i class="bi bi-list-check green-lt-icon" aria-hidden="true"></i>Subscription Feature
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/subscription-feature-assign">
          <i class="bi bi-link-45deg blue-lt-icon" aria-hidden="true"></i>Assign Feature
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/subscription-license-list">
          <i class="bi bi-card-checklist blue-lt-icon" aria-hidden="true"></i>License
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/subscription-license-category-list">
          <i class="bi bi-folder green-lt-icon" aria-hidden="true"></i>License Category
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/subscription-license-route-list">
          <i class="bi bi-signpost-split green-lt-icon" aria-hidden="true"></i>License Routes
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/subscription-license-rights">
          <i class="bi bi-shield-check orange-dr-icon" aria-hidden="true"></i>License Rights
        </button>
      </div>
      <!-- <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/faq">
          <i class="bi bi-gear green-lt-icon" aria-hidden="true"></i>Webinar Library
        </button>
      </div> -->
    </div>
  </fieldset>
</div>
<div class="container mt-1 theme-fa-icon" >
  <fieldset class="scheduler-border">
    <legend class="scheduler-border">
      <h5 class="font-weight-bold">License Bundle</h5>
    </legend>
    <div class="row">
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/license-bundle-listing">
          <i class="fa fa-book blue-lt-icon" aria-hidden="true"></i>Bundle Management
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/license-assign-listing">
          <i class="fa fa-id-card-o green-lt-icon" aria-hidden="true"></i>Assign Bundle
        </button>
      </div>
      <div class="col-xl-4 col-md-6">
        <button class="cbtn mt-1" routerLink="/corporate/addon-catalog-list">
          <i class="fa fa-tags orange-dr-icon" aria-hidden="true"></i>Add-on Catalog
        </button>
      </div>
    </div>
  </fieldset>
</div>
